import { ActivityFieldHydration } from '../../../shared/modules/activity/dtos/activity-field-hydration.dto';
import { ActivityLinkHydration } from '../../../shared/modules/activity/dtos/activity-link-hydration.dto';
import { AgentSearchDto } from '../../agents';
import { CustomerSearchDto } from '../../customers';
import { LocationSearchDto } from '../../locations';
import { RentalAgreementSearchDto } from '../../rental-agreements';
import { RentalReservationSearchDto } from '../../rental-reservations';
import { SupplierSearchDto } from '../../suppliers/dtos/supplier-search.dto';
import { VehicleInsuranceSearchDto } from '../../vehicle-insurances';
import { VehicleMaintenanceSearchDto } from '../../vehicle-maintenances';
import { VehicleRoadTaxSearchDto } from '../../vehicle-road-taxes';
import { VehicleRoadWorthyCheckSearchDto } from '../../vehicle-road-worthy-checks';
import { VehicleSearchDto } from '../../vehicles';

/**
 * Resolved related records for a transaction activity event, keyed by relation.
 */
export class TransactionActivityEventHydration {
  customer?: ActivityFieldHydration<CustomerSearchDto>;
  supplier?: ActivityFieldHydration<SupplierSearchDto>;
  agent?: ActivityFieldHydration<AgentSearchDto>;
  location?: ActivityFieldHydration<LocationSearchDto>;
  vehicle?: ActivityFieldHydration<VehicleSearchDto>;
  rentalAgreement?: ActivityFieldHydration<RentalAgreementSearchDto>;
  rentalReservation?: ActivityFieldHydration<RentalReservationSearchDto>;
  vehicleRoadTax?: ActivityFieldHydration<VehicleRoadTaxSearchDto>;
  vehicleInsurance?: ActivityFieldHydration<VehicleInsuranceSearchDto>;
  vehicleRoadWorthyCheck?: ActivityFieldHydration<VehicleRoadWorthyCheckSearchDto>;
  vehicleMaintenance?: ActivityFieldHydration<VehicleMaintenanceSearchDto>;
  link?: ActivityLinkHydration;
}
